import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { WidgetAddLandlordPropertiesComponent } from '@platform/dashboard/components/widget-container/components/widget-add-landlord-properties/widget-add-landlord-properties.component';
import { WidgetEpcImprovementsComponent } from '@platform/dashboard/components/widget-container/components/widget-epc-improvements/widget-epc-improvements.component';
import { WidgetRemortgageGuideComponent } from '@platform/dashboard/components/widget-container/components/widget-remortgage-guide/widget-remortgage-guide.component';
import { DashboardWidgetType } from '@platform/dashboard/enums/dashboard-news-banner-type.enum';
import { DashboardWidget } from '@platform/dashboard/models/dashboard-news-banner.model';
import { paths } from '@platform/paths';
import { ButtonModule } from 'primeng/button';
import { WidgetAddPropertyComponent } from './components/widget-add-property/widget-add-property.component';
import { WidgetAddSmartSearchComponent } from './components/widget-add-smart-search/widget-add-smart-search.component';
import { WidgetBestDealComponent } from './components/widget-best-deal/widget-best-deal.component';
import { WidgetBetterDealComponent } from './components/widget-better-deal/widget-better-deal.component';
import { WidgetHasCaseComponent } from './components/widget-has-case/widget-has-case.component';
import { WidgetMinimalDataComponent } from './components/widget-minimal-data/widget-minimal-data.component';

@Component({
  selector: 'cp-widget-container',
  imports: [
    CommonModule,
    ButtonModule,
    WidgetBetterDealComponent,
    WidgetAddSmartSearchComponent,
    WidgetBestDealComponent,
    WidgetRemortgageGuideComponent,
    WidgetHasCaseComponent,
    WidgetAddLandlordPropertiesComponent,
    WidgetEpcImprovementsComponent,
    WidgetMinimalDataComponent,
    WidgetAddPropertyComponent,
  ],
  templateUrl: './widget-container.component.html',
  styleUrl: './widget-container.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WidgetContainerComponent {
  @Input() widgetData: { key: DashboardWidgetType; value: DashboardWidget[] };
  @Input() widget: DashboardWidget;
  @Input() closeable = false;
  protected readonly DashboardWidgetType = DashboardWidgetType;
  protected readonly paths = paths;
}
